module.exports = __webpack_public_path__ + "static/img/error.589ecd1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/error.jpg
// module id = jle9
// module chunks = 1